import setup from './moduleSetup';

export default {
    name: 'headerMenuItems',
    before: [],
    after: [],
    setup,
};
